import styled from 'styled-components';
import { Popover } from '@landlord-tech/ui-kit-opp/dist/components/Popover';

export const SPopover = styled(Popover)`
  &&& {
  }
`;
